export default "__VITE_ASSET__89bfef03__"